module.exports = __webpack_public_path__ + "static/stack-279eea1dd71bb485a523dd79d4f0fc5a.svg";